import React from 'react';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';

const documents = [
  {
    title: 'Hvordan får jeg den rigtige fragtpris',
    desc: 'Instruktion 3.3.16 rev. 00 med råd til præcis forespørgsel og optimal fragtrate.',
    url: 'https://assets.auxodev.dk/assets/2e6d0d1c-821d-400c-80aa-275c6c0c86cc/3-3-16-rev-00-hvordan-jeg-f-r-den-rigtige-fragtpris.pdf',
    tag: 'Priser'
  },
  {
    title: 'Godsets vej',
    desc: 'Forstå godsets rejse gennem terminaler og transportkæden.',
    url: 'https://assets.auxodev.dk/assets/2e6d0d1c-821d-400c-80aa-275c6c0c86cc/instruktion-godsets-vej.pdf',
    tag: 'Instruktion'
  },
  {
    title: 'Mærkning af gods',
    desc: 'Korrekt mærkning og colli-angivelse til forebyggelse af forsinkelser og bortkomst.',
    url: 'https://assets.auxodev.dk/assets/2e6d0d1c-821d-400c-80aa-275c6c0c86cc/instruktion-maerking.pdf',
    tag: 'Kvalitet'
  },
  {
    title: 'Emballering af gods',
    desc: 'Instruktion 3.3.2 rev. 02 om forsvarlig pakning og sikring til international transport.',
    url: 'https://assets.auxodev.dk/assets/2e6d0d1c-821d-400c-80aa-275c6c0c86cc/3-3-2-rev-02-instruktion-emballering.pdf',
    tag: 'Pakning'
  },
  {
    title: 'Farligt gods (ADR / IMDG)',
    desc: 'Instruktion 3.3.4 rev. 01 om regler, klassificering, mærkning og dokumentation.',
    url: 'https://assets.auxodev.dk/assets/2e6d0d1c-821d-400c-80aa-275c6c0c86cc/3-3-4-rev-01-instruktion-farligtgods.pdf',
    tag: 'ADR'
  },
  {
    title: 'Forsikring af gods',
    desc: 'Instruktion om fragtforsikring og transportørens ansvarsbegrænsninger.',
    url: 'https://assets.auxodev.dk/assets/2e6d0d1c-821d-400c-80aa-275c6c0c86cc/instruktion-forsikring-rev-00.pdf',
    tag: 'Forsikring'
  },
  {
    title: 'Fremgangsmåde ved Skade',
    desc: 'Instruktion 3.3.15 rev. 00 med retningslinjer for forbehold og skadesanmeldelse.',
    url: 'https://assets.auxodev.dk/assets/2e6d0d1c-821d-400c-80aa-275c6c0c86cc/3-3-15-rev-00-fremgangsm-de-ved-skade.pdf',
    tag: 'Skade'
  },
  {
    title: 'Handelsfaktura',
    desc: 'Instruktion 3.3.14 rev. 01 om krav til proforma- og handelsfakturaer.',
    url: 'https://assets.auxodev.dk/assets/2e6d0d1c-821d-400c-80aa-275c6c0c86cc/3-3-14-rev-01-instruktion-handelsfaktura.pdf',
    tag: 'Dokumentation'
  },
  {
    title: 'Generelle Forretningsbetingelser',
    desc: 'Fastlanes forretningsbetingelser baseret på NSAB og gældende transportlovgivning.',
    url: 'https://assets.auxodev.dk/assets/2e6d0d1c-821d-400c-80aa-275c6c0c86cc/forretningsbet-dk-07.pdf',
    tag: 'Betingelser'
  },
  {
    title: 'Incoterms 2020 Oversigt',
    desc: 'Skematisk guide over leveringsbetingelser, omkostninger og risikoovergang.',
    url: 'https://assets.auxodev.dk/assets/2e6d0d1c-821d-400c-80aa-275c6c0c86cc/incoterms-2020-fastlane-5.pdf',
    tag: 'Handel'
  },
  {
    title: 'Instruktion Containertyper',
    desc: 'Instruktion 3.3.8 rev. 00 med dimensioner og specifikationer for skibscontainere.',
    url: 'https://assets.auxodev.dk/assets/2e6d0d1c-821d-400c-80aa-275c6c0c86cc/3-3-8-rev-00-instruktion-containertyper-0.pdf',
    tag: 'Container'
  },
  {
    title: 'Container Godkendelse (CSC)',
    desc: 'Instruktion 3.3.6 rev. 00 om Container Safety Convention og gyldighedskrav.',
    url: 'https://assets.auxodev.dk/assets/2e6d0d1c-821d-400c-80aa-275c6c0c86cc/3-3-6-rev-00-instruktion-container-godkendelse.pdf',
    tag: 'Container'
  },
  {
    title: 'Persondatapolitik (GDPR)',
    desc: 'Instruktion 3.3.13 rev. 00 om behandling af persondata i overensstemmelse med GDPR.',
    url: 'https://assets.auxodev.dk/assets/2e6d0d1c-821d-400c-80aa-275c6c0c86cc/3-3-13-rev-00-instruktion-persondatapolitik.pdf',
    tag: 'GDPR'
  }
];

export default function Downloads() {
  return (
    <>
      <SEO
        title="Kendskab/Downloads | Fastlane ApS"
        description="General Data Protection Regulation (GDPR). På dansk kaldet Persondataforordningen. Hent nyttige instruktioner, Incoterms, forretningsbetingelser og emballeringsguides fra Fastlane ApS."
        canonicalUrl="https://fastlane.dk/kendskabdownloads"
      />

      <PageHeader
        title="Kendskab / Downloads"
        subtitle="Nyttige instruktioner, lovgivning, forretningsbetingelser og vejledninger til fri download."
        breadcrumbs={[{ label: 'Kendskab/Downloads' }]}
      />

      <div className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          <div className="bg-slate-50 border border-slate-200/90 rounded-2xl p-6 sm:p-8 space-y-4">
            <h2 className="text-xl font-bold text-[#0f2b48]">Vejledende instruktioner og regler for transport</h2>
            <p className="text-sm text-slate-700 leading-relaxed">
              Når gods sendes som partigods eller stykgods er det vigtigt at forholde sig til at godset normalt omlæsses via terminal en del gange. Det stiller krav til mærkning, pakning m.m. Herunder finder du vores samlede bibliotek af eksterne instruktioner.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
            {documents.map((doc, idx) => (
              <a
                key={idx}
                href={doc.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex flex-col justify-between p-5 rounded-xl border border-slate-200 hover:border-sky-400 bg-white hover:bg-sky-50/20 shadow-2xs hover:shadow-md transition-all focus:outline-hidden focus:ring-2 focus:ring-sky-600"
              >
                <div>
                  <div className="flex items-center justify-between gap-2 mb-2">
                    <span className="text-[11px] font-bold uppercase tracking-wider text-sky-700 px-2 py-0.5 rounded-sm bg-sky-50 border border-sky-100">
                      {doc.tag}
                    </span>
                    <i className="fa-solid fa-file-pdf text-red-600 text-lg group-hover:scale-110 transition-transform" aria-hidden="true" />
                  </div>
                  <h3 className="text-base font-bold text-[#0f2b48] group-hover:text-sky-800 transition-colors mb-1.5">
                    {doc.title}
                  </h3>
                  <p className="text-xs text-slate-600 leading-relaxed">
                    {doc.desc}
                  </p>
                </div>

                <div className="pt-4 mt-4 border-t border-slate-100 flex items-center justify-between text-xs font-semibold text-sky-700">
                  <span>Hent PDF dokument</span>
                  <i className="fa-solid fa-download text-xs group-hover:translate-y-0.5 transition-transform" aria-hidden="true" />
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
